<template>
  <div>
    <vxe-grid
      ref="grid"
      v-bind="xGridOptions"
      highlight-hover-row
      show-overflow="title"
      border
      resizable
      height="480"
      @cell-click="cellClick"
      :loading="loading"
      :radio-config="{trigger:'row'}"
    ></vxe-grid>
  </div>
</template>

<script>
import { UnitmanageApi } from "api/base.js";
import FormGridPWindow from "components/grid/FormGridPWindow.vue";

export default {
  components: {
    FormGridPWindow
  },
  props: {
    tableColumns: {
      Type: Array
    }
  },
  data() {
    return {
      loading: false,
      fromData: {
        page: 1, //当前页
        pageSize: 100 //总数量,
      },
      EditData: {
        materialDto: {}
      },
      xGridOptions: {
        resizable: true, //列是否允许拖动列宽调整大小
        height: "100%",
        
        toolbar: {
          // buttons: [
          // { code: 'insert_actived', name: 'Add', icon: 'fa fa-plus' },
          // { code: 'mark_cancel', name: '删除/取消', icon: 'fa fa-bookmark-o' },
          // { code: 'save', name: 'Save', icon: 'fa fa-save' }
          // ],
          import: true,
          perfect: true,
          refresh: true,
          custom: true,
          export: true,
          zoom: true
        }, 
        data: [],
        exportConfig: {},
        importConfig: {
          remote: true,
          types: ["xlsx"],
          modes: ["insert"]
        },
        columns: this.tableColumns
      }
    };
  },
  created() {
    this.getList();
  },
  methods: {
    //编辑时需要用到的
    onEditUnit() {
      let radioData = this.$refs.grid.getRadioRecord();
      if (radioData) {
        // console.log(radioData.tenantId)
        this.$emit("EdUnitId", radioData.unitId);
      } else {
        this.$emit("EdUnitId", null);
      }
    },
    //获取列表
    async getList() {
      this.loading = true;
      let res = await this.$post(UnitmanageApi.list,this.fromData);
      console.log(res);
      if (res.status && res.data) {
        this.xGridOptions.data = res.data.list;
        this.loading = false;
      } else {
        this.xGridOptions.data = [];
        this.loading = false;
      }
    },
    cellClick(data){
        console.log(data.row)
        this.$emit("cellClick", data.row);
    }
  }
};
</script>

<style>
.vxe-grid .warning-row {
    background: oldlace;
  }
</style>
